import { createContext, useContext, useReducer } from "react";
import Dashboard_reducer from "../reducer/Dashboard_reducer";
import {
  GET_FORM_LIST_BEGIN,
  GET_FORM_LIST_ERROR,
  GET_FORM_LIST_SUCCESS,
  SELECTED_LIST_BEGIN,
  SELECTED_LIST_ERROR,
  SELECTED_LIST_SUCCESS,
  TOGGLE_SELECT_BEGIN,
  TOGGLE_SELECT_ERROR,
  TOGGLE_SELECT_SUCCESS,
  SET_SELECTED_PROFILE,
} from "../utils/action";
import axios from "axios";
import {
  ACCEPT_HEADER,
  get_form_list_url,
  is_select_url,
  selected_list_url,
} from "../utils/constant.js";
import { useLoginContext } from "../context/Login_context.js";
import Notification from "../utils/Notification.js";

const DashboardContext = createContext();

const initialState = {
  dashboard_loading: false,
  dashboard_Data: [],
  selected_data: [],
  selected_loading: false,
  is_select_load: false,
  selected_profile:
    JSON.parse(localStorage.getItem("selected_profile")) || null,
};

export const DashboardProvider = ({ children }) => {
  const [state, dispatch] = useReducer(Dashboard_reducer, initialState);
  const { setLogout } = useLoginContext();

  const getToken = () => localStorage.getItem("token");

  const GetformList = async (formdata) => {
    const token = getToken();
    dispatch({ type: GET_FORM_LIST_BEGIN });

    axios
      .post(get_form_list_url, formdata, {
        headers: {
          Accept: ACCEPT_HEADER,
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        if (res.data.status === "Token is Expired") {
          setLogout();
        } else if (res.data.status === "success") {
          dispatch({ type: GET_FORM_LIST_SUCCESS, payload: res.data.data });
        } else {
          dispatch({ type: GET_FORM_LIST_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get Form List Api ", err);
        dispatch({ type: GET_FORM_LIST_ERROR });
      });
  };

  const GetSelectedList = async () => {
    const token = getToken();
    dispatch({ type: SELECTED_LIST_BEGIN });

    axios
      .get(selected_list_url, {
        headers: {
          Accept: ACCEPT_HEADER,
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        if (res.data.status === "Token is Expired") {
          setLogout();
        } else if (res.data.status === "success") {
          dispatch({ type: SELECTED_LIST_SUCCESS, payload: res.data.data });
        } else {
          dispatch({ type: SELECTED_LIST_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in get selected list api ", err);
        dispatch({ type: SELECTED_LIST_ERROR });
      });
  };

  const SelectPerson = async (formdata, navigate) => {
    const token = getToken();
    dispatch({ type: TOGGLE_SELECT_BEGIN });

    axios
      .post(is_select_url, formdata, {
        headers: {
          Accept: ACCEPT_HEADER,
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        if (res.data.status === "Token is Expired") {
          setLogout();
        } else if (res.data.status === true) {
          Notification("success", res?.data?.message);
          GetSelectedList(navigate);
          GetformList(formdata, navigate);
          dispatch({ type: TOGGLE_SELECT_SUCCESS });
        } else {
          dispatch({ type: TOGGLE_SELECT_ERROR });
        }
      })
      .catch((err) => {
        console.log("🔥 FULL ERROR:", err);
        console.log("🔥 BACKEND MESSAGE:", err.response?.data);

        dispatch({ type: TOGGLE_SELECT_ERROR });
      });
  };

  const setSelectedProfile = (profile) => {
    localStorage.setItem("selected_profile", JSON.stringify(profile));
    dispatch({ type: SET_SELECTED_PROFILE, payload: profile });
  };

  return (
    <DashboardContext.Provider
      value={{
        ...state,
        GetformList,
        GetSelectedList,
        SelectPerson,
        setSelectedProfile,
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

export const useDashboardContext = () => {
  return useContext(DashboardContext);
};
